import React, { useState, useRef } from "react";
import styles from "./CameraCapture.module.css";

const CameraCapture = ({ image, setImage, uploadImage, location, setLocation, onClose }) => {
    const [capturing, setCapturing] = useState(false);
    const [cameraFacing, setCameraFacing] = useState("user"); // "user" for front, "environment" for back
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    let streamRef = useRef(null);

    // Request access to the camera
    const startCamera = async () => {
        setCapturing(true);
        try {
            // Stop any existing stream
            if (streamRef.current) {
                stopCamera();
            }

            const stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: cameraFacing }
            });

            if (videoRef.current) {
                videoRef.current.srcObject = stream;
                streamRef.current = stream; // Store stream reference
            }
        } catch (error) {
            console.error("Error accessing camera:", error);
        }
    };

    // Switch camera between front and back
    const switchCamera = () => {
        setCameraFacing((prev) => (prev === "user" ? "environment" : "user"));
        startCamera(); // Restart camera with new facing mode
    };

    // Capture Image
    const captureImage = () => {
        if (videoRef.current && canvasRef.current) {
            const context = canvasRef.current.getContext("2d");
            context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);
            const imageData = canvasRef.current.toDataURL("image/png"); // Convert image to Base64
            setImage(imageData);
            stopCamera();
        }
        setCapturing(false);
    };

    // Stop the camera stream
    const stopCamera = () => {
        if (streamRef.current) {
            streamRef.current.getTracks().forEach(track => track.stop());
            streamRef.current = null;
        }
    };

    // Get Geolocation
    const getLocation = () => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLocation({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                },
                (error) => {
                    console.error("Error getting location:", error);
                }
            );
        } else {
            console.error("Geolocation not supported");
        }
    };

    return (
        <div style={{ textAlign: "center", padding: "20px" }} className={styles.container}>
            <div className={styles.divBox}>
                {/* Close Button */}
                <button className={styles.closeButton} onClick={onClose}>&times;</button>

                {/* Camera View */}
                {!image && (
                    <div>
                        <video ref={videoRef} autoPlay playsInline width="300" height="200"></video>
                        <br />
                        {!capturing &&
                            <button onClick={startCamera} className={styles.button} disabled={capturing}>Start Camera</button>
                        }
                        {capturing && (
                            <>
                                <button onClick={captureImage} className={styles.button}>Capture</button>
                                <button onClick={switchCamera} className={styles.button}>
                                    Switch Camera
                                </button>
                            </>
                        )}
                    </div>
                )}

                {/* Captured Image */}
                {image && (
                    <div>
                        <img src={image} alt="Captured" width="300" />
                    </div>
                )}

                {console.log("image is " + image)}

                {/* Location Info */}
                {image && (
                    location?.latitude && location?.longitude ? (
                        <p className={styles.LocationP}>Latitude: {location?.latitude}, Longitude: {location?.longitude}</p>
                    ) : (
                        <button className={styles.button} onClick={getLocation}>Get Location</button>
                    )
                )}

                {/* Upload Button */}
                {image && (
                    <button className={`${styles.button} ${styles.uploadButton}`} onClick={uploadImage} disabled={!image || !location?.latitude}>Upload</button>
                )}

            </div>

            {/* Canvas (Hidden) */}
            <canvas ref={canvasRef} width="300" height="200" style={{ display: "none" }}></canvas>
        </div>
    );
};

export default CameraCapture;
